import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import sass from '../assets/sass.png';
import framer from '../assets/framer-motion.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/graham-greer-profile-photo.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

export default {
  email,
  mobile,
  api,
  css,
  figma,
  git,
  html,
  javascript,
  mu5,
  node,
  react,
  sass,
  framer,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
};